import { GET_ALL_VISITS } from './constants';
import { Patient } from './fetchPrescriptionById';
import fetchWithRefresh from './fetchWithRefresh';
import { Tool } from './pushVisit';

export enum VISIT_TYPE {
    SELF = 'self',
    BUSINESS = 'business',
    MR = 'mr',
}

export type VisitTool = {
    id: string;
    visitId: string;
    tool: Tool;
    date: string;
    visitName: string;
    patient: Patient;
    flavour?: 'DW' | 'AN' | 'IO' | string;
    translateLang?: string;
    type?: VISIT_TYPE;
    doc_name?: string;
};

export interface RequestResponse {
    success: boolean;
    data?: VisitTool[];
    error?: string;
}

export default (ptId: string, limit: number = 0): Promise<RequestResponse> => {
    return fetchWithRefresh(GET_ALL_VISITS(ptId, limit), {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
